var _defs, _polyline, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.54 93.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46.9 91 64.9 89 74.9 65 69.9 43 38.9 35 37.9 5 23.83 5.84 24.9 51 9.9 42 3.9 52 23.9 75 32.9 91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.45,70.2a3.78,3.78,0,0,0,.28-1.45V55.46A11.7,11.7,0,0,0,61.56,44l-26-5.77V11.71a3.9,3.9,0,0,0-7.8,0V60.16L15.28,47.65a4.38,4.38,0,0,0-6.19,6.19L25.76,70.5a11.59,11.59,0,0,1,2.19,3l6.16,12.32H64.19ZM20,11.71a11.71,11.71,0,1,1,23.42,0V32l19.84,4.41A19.51,19.51,0,0,1,78.54,55.46V68.75a11.77,11.77,0,0,1-.84,4.35L69.47,93.68H29.29L21,77a4.12,4.12,0,0,0-.73-1L3.57,59.36A12.18,12.18,0,0,1,20,41.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCursor);
export default __webpack_public_path__ + "static/media/handCursor.fb9ea95000aeba6c0823def42736e8a2.svg";
export { ForwardRef as ReactComponent };